// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './dashboard.es-AR.json';
import esCL from './dashboard.es-CL.json';
import esCO from './dashboard.es-CO.json';
import esMX from './dashboard.es-MX.json';
import ptBR from './dashboard.pt-BR.json';

const dashboardTranslations: DomainTranslations = {
  name: 'dashboard',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.COLOMBIA]: esCO,
    [Locale.CHILE]: esCL,
  },
};

export default dashboardTranslations;
